import { SearchChip } from '@nexelem/inputs';
import { useCallback } from 'react';
import { useTableTranslation } from '../translations';
import { useFilterController } from './useFilterController';

type SearchProps = {
  name: string;
  placeholder?: string;
};

export const Search = ({ name, placeholder }: SearchProps) => {
  const { t } = useTableTranslation();
  const {
    field: { onChange, value, ...field },
  } = useFilterController({ name, defaultValue: '' });

  const handleChange = useCallback(
    (value: string) => {
      onChange(value === '' ? value : value);
    },
    [onChange],
  );

  return (
    <SearchChip
      className="max-w-60"
      placeholder={placeholder ?? t('searchPlaceholder')}
      value={value ?? ''}
      onChange={handleChange}
      {...field}
    />
  );
};
